import React, { useCallback } from "react";
import { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";
import { connect } from "react-redux";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import JamezzTableV2 from "../../components/JamezzTable/V2/JamezzTableV2";
import { Add, Delete, Lock, MenuBook } from "@mui/icons-material";
import { unwrap } from "../../unwrap";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import { Link } from "react-router";
import Button from "../../components/CustomButtons/Button";
import { IconButton, TableCell, Tooltip, Typography } from "@mui/material";
import AreYouSureDialog from "../../components/Dialogs/AreYouSureDialog";
import { _post } from "../../http";
import Edit from "@mui/icons-material/Edit";

const endPoint = "core/timeschedule";

function Timeschedules(props: { vestiging_id: number; appTarget: string }) {
  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      { id: "name", label: getTranslation("timeschedules.name", "Name") },
    ],
    []
  );

  const renderRowCells = useCallback(
    (row) => (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>{row.name.length ? row.name : "No name"}</TableCell>
      </>
    ),
    []
  );

  const renderSelectionActions = useCallback((selected) => {
    return (
      <Tooltip title={<TranslationWrapper tKey={"Delete"} />}>
        <IconButton
          onClick={() => {
            openDialog({
              children: (
                <AreYouSureDialog
                  content={<TranslationWrapper tKey={"Are you sure you want to delete the selected?"} />}
                  onOk={() => {
                    _post(`${endPoint}/multipledelete`, { ids: selected }).then(() => {
                      updateReloadState();
                    });
                  }}
                />
              ),
            });
          }}
          style={{ color: "lightcoral" }}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    );
  }, []);

  const renderRowActions = useCallback((row) => {
    return (
      <TableCell align={"right"}>
        <Link to={`./${row.id}/edit`}>
          <Tooltip
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Edit timeschedule"} tKey={"timeschedule.edit"} />}
          >
            <IconButton color={"primary"} simple size={"small"}>
              <Edit />
            </IconButton>
          </Tooltip>
        </Link>
      </TableCell>
    );
  }, []);

  const salesarea = unwrap(props.vestiging_id);

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tDefault={"timeschedules"} tKey={"timeschedules"} />} />

      {salesarea ? (
        <AuthenticationWrapper
          child={
            <Link to={"./create"}>
              <Button color={"success"}>
                <Add />{" "}
                <TranslationWrapper
                  tDefault={"Create a new timeschedule"}
                  tKey={"timeschedules.createNewTimeschedule"}
                />
              </Button>
            </Link>
          }
          permissionKey={"timeschedules.create"}
        />
      ) : (
        <Typography>
          <Lock />
          <TranslationWrapper tKey={"Select a salesarea before starting"} />
        </Typography>
      )}

      <JamezzTableV2
        checkboxSelection={true}
        dense={true}
        endPoint={endPoint}
        filters={{}}
        headerIcon={<MenuBook />}
        renderCellsForRow={renderRowCells}
        renderHeaderCells={renderHeaderCells}
        renderRowActions={renderRowActions}
        renderSelectionActions={renderSelectionActions}
        tableTitle={<TranslationWrapper tDefault={"timeschedules"} tKey={"timeschedules"} />}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  const filters = getVestigingFilterState(state, true);

  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
    appTarget: state.filtersV2.vestiging_id?.appTarget,
  };
};

export default connect(mapStateToProps)(Timeschedules);
